var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.624,16.875l.833-5.429h-5.21V7.922a2.715,2.715,0,0,1,3.061-2.933h2.368V.367A28.882,28.882,0,0,0,13.473,0C9.183,0,6.378,2.6,6.378,7.308v4.138H1.609v5.429H6.378V30h5.869V16.875Z","transform":"translate(-1.609)","fill":"#fff"}));
}

Facebook.defaultProps = {"width":"16.068","height":"30","viewBox":"0 0 16.068 30"};

module.exports = Facebook;

Facebook.default = Facebook;
